export const toRadians = (degrees: number): number => degrees * (Math.PI / 180)
